import Request from "./request";
const User = "/user";
const UserInfo = "/user/info";
const Abilities = "/user/abilities";
const Education = "/user/educations";
const Job = "/user/historyJobs";
// import qs from "qs";
const Project = "/user/historyProjects";
const Intention = "/user/intentionJobs";
const recommend = "/projects/recommend";

export default {
  //用户
  async getUser() {
    return Request.get(UserInfo);
  },
  async getUserDetail() {
    return Request.get(`${User}/details`);
  },
  async EditUser(query) {
    return Request.put(UserInfo, query);
  },
  //用户教育
  async getEduction(query) {
    return Request.get(Education, query);
  },
  async getEductionDetail(id) {
    return Request.get(`${Education}/${id}`);
  },
  async CreateEducation(data) {
    return Request.post(Education, data);
  },
  async EditEducation(data, id) {
    return Request.put(`${Education}/${id}`, data);
  },
  async deleteEducation(id) {
    return Request.delete(`${Education}/${id}`);
  },
  //工作经历
  async getJobHistoryDetail(id) {
    return Request.get(`${Job}/${id}`);
  },
  async createJobHistory(data) {
    return Request.post(Job, data);
  },
  async editJobHistory(data, id) {
    return Request.put(`${Job}/${id}`, data);
  },
  async deleteJobHistory(id) {
    return Request.delete(`${Job}/${id}`);
  },
  //项目经历
  async getProjectHistoryDetail(id) {
    return Request.get(`${Project}/${id}`);
  },
  async createProjectHistory(data) {
    return Request.post(Project, data);
  },
  async editProjectHistory(data, id) {
    return Request.put(`${Project}/${id}`, data);
  },
  async deleteProjectHistory(id) {
    return Request.delete(`${Project}/${id}`);
  },
  //专业能力
  async getAbilities(query) {
    return Request.get(Abilities, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getAbilitiesId(id, formId) {
    return Request.get(`${Abilities}/${id}/form/${formId}`);
  },
  async createAbilities(data) {
    return Request.post(Abilities, data);
  },
  async editAbilities(data, id) {
    return Request.put(`${Abilities}/${id}`, data);
  },
  async deleteAbilities(id, formId) {
    return Request.delete(`${Abilities}/${id}/form/${formId}`);
  },
  //求职意向
  async getIntention(query) {
    return Request.get(Intention, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getIntentionId(id, formId) {
    return Request.get(`${Intention}/${id}/form/${formId}`);
  },
  async createIntention(data) {
    return Request.post(Intention, data);
  },
  async editIntention(data, id) {
    return Request.put(`${Intention}/${id}`, data);
  },
  async deleteIntention(id, formId) {
    return Request.delete(`${Intention}/${id}/form/${formId}`);
  },
  //用户自荐
  async RecommendIntention(data) {
    return Request.post(recommend, data);
  },
  //微信绑定手机号
  async bindMobile(query) {
    return Request.put("/user/wechat/bindmobile", query);
  },
  //手机号绑定微信
  async bindwechat(appId, code) {
    let data = {
      appId: appId,
      code: code
    };
    return Request.put("/user/mobile/bindwechat", data);
  }
};
